<template>
    <v-container fluid v-if="authUser">
        <v-row class="pb-0 pb-sm-10">
            <v-col cols="12">
                <div class="display-1">{{ $t("profile") }}</div>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" lg="12" xl="10">
                <CreditScoreTemplate></CreditScoreTemplate>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" lg="12" xl="10">
                <v-card class="pa-md-4">
                    <v-card-title class="headline">
                        {{ $t("personal_info") }}
                    </v-card-title>
                    <v-card-text class="pl-md-10 pr-md-10">
                        <v-row>
                            <v-col cols="12" xl="5" lg="5" md="5" sm="12" class="pa-6">
                                <v-text-field
                                    v-model="authUser.surname"
                                    v-validate="'required|max:50'"
                                    :error-messages="errors.collect('surname')"
                                    data-vv-name="surname"
                                    required
                                    :label="$t('surname')"
                                    outlined
                                ></v-text-field>
                                <v-text-field
                                    v-model="authUser.name"
                                    v-validate="'required|max:50'"
                                    :error-messages="errors.collect('name')"
                                    data-vv-name="name"
                                    required
                                    :label="$t('name')"
                                    outlined
                                ></v-text-field>
                                <v-text-field
                                    v-model="authUser.second_name"
                                    v-validate="'max:50'"
                                    :error-messages="errors.collect('second_name')"
                                    data-vv-name="second_name"
                                    :label="$t('second_name')"
                                    outlined
                                ></v-text-field>

                                <div v-if="settings.payments.enabled">
                                    <p>{{ $t("pay.card_list") }}:</p>
                                    <div
                                        v-if="
                                            authUser.payment_credentials &&
                                            authUser.payment_credentials.length
                                        "
                                    >
                                        <div v-for="credentials in authUser.payment_credentials">
                                            <CreditCardBox
                                                :credentials="credentials"
                                            ></CreditCardBox>
                                        </div>

                                        <a
                                            @click="addCreditCard"
                                            style="font-size: 13px; text-decoration: underline;"
                                        >
                                            {{ $t("pay.add") }}
                                        </a>
                                    </div>

                                    <div
                                        v-if="
                                            !authUser.payment_credentials ||
                                            !authUser.payment_credentials.length
                                        "
                                    >
                                        <NoCreditCardBox
                                            :add-card="addCreditCard"
                                        ></NoCreditCardBox>
                                    </div>
                                </div>
                            </v-col>

                            <div class="hidden-sm-and-down">
                                <v-divider vertical></v-divider>
                            </div>

                            <v-col cols="12" xl="5" lg="5" md="5" sm="12" class="pa-6">
                                <v-row no-gutters>
                                    <v-col cols="undefined">
                                        <v-text-field
                                            v-model="authUser.phone"
                                            v-validate="'required'"
                                            :error-messages="errors.collect('phone')"
                                            data-vv-name="phone"
                                            required
                                            v-mask="$t('mask.phone')"
                                            :readonly="authUser.is_phone_confirm"
                                            :label="
                                                authUser.is_phone_confirm
                                                    ? $t('phone_number')
                                                    : $t('not_confirmed')
                                            "
                                            :error="!authUser.is_phone_confirm"
                                            :hide-details="!authUser.is_phone_confirm"
                                            outlined
                                        >
                                        </v-text-field>
                                        <p
                                            v-if="!authUser.is_phone_confirm"
                                            class="mt-1 v-messages"
                                            @click="verificatePhoneModal()"
                                        >
                                            {{ $t("phone_not_confirmed") }}.
                                            <a>{{ $t("confirm") }}</a>
                                        </p>
                                    </v-col>
                                </v-row>

                                <v-row class="hidden-lg-and-up">
                                    <v-col></v-col>
                                </v-row>

                                <v-row no-gutters>
                                    <v-col cols="undefined">
                                        <v-text-field
                                            v-model="authUser.email"
                                            v-validate="'required|email'"
                                            :error-messages="errors.collect('email')"
                                            data-vv-name="email"
                                            required
                                            :readonly="authUser.is_email_confirm"
                                            :label="
                                                authUser.is_email_confirm
                                                    ? $t('email')
                                                    : $t('not_confirmed')
                                            "
                                            :error="!authUser.is_email_confirm"
                                            :hide-details="!authUser.is_email_confirm"
                                            outlined
                                        >
                                        </v-text-field>
                                        <p
                                            v-if="!authUser.is_email_confirm"
                                            class="mt-1 v-messages"
                                            @click="verificateEmailModal()"
                                        >
                                            {{ $t("email_not_confirmed") }}.
                                            <a>{{ $t("confirm") }}</a>
                                        </p>
                                    </v-col>
                                </v-row>
                                <v-row class="hidden-sm-and-down">
                                    <v-col>
                                        <v-btn color="info" outlined @click="changePasswordModal()">
                                            {{ $t("change_password") }}
                                        </v-btn>
                                    </v-col>
                                </v-row>
                            </v-col>
                        </v-row>
                        <v-row class="d-flex justify-end">
                            <v-btn
                                class="hidden-md-and-up"
                                color="info"
                                outlined
                                style="margin-top: 12px;"
                                @click="changePasswordModal()"
                            >
                                {{ $t("change_password") }}
                            </v-btn>
                            <v-btn
                                color="primary"
                                style="margin-left: 12px; margin-top: 12px;"
                                @click="saveProfile()"
                            >
                                {{ $t("save") }}
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="center">
            <v-col cols="12" lg="12" xl="10">
                <v-card>
                    <v-card-text>
                        <v-row justify="center">
                            <v-btn text x-small @click="openPersonalDataModal()">
                                {{ $t("personal_terms_title") }}
                            </v-btn>
                            <v-btn text x-small @click="openUserTermsModal()">
                                {{ $t("terms_of_use_title") }}
                            </v-btn>
                        </v-row>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <ValidatePhone></ValidatePhone>
        <VerificateEmailModal :user="authUser"></VerificateEmailModal>
        <ChangePasswordModal></ChangePasswordModal>
        <PersonalDataModal></PersonalDataModal>
        <UserTermsModal></UserTermsModal>
    </v-container>
</template>

<script>
import CreditCardBox from "@/app/client/ui/CreditCardBox";
import NoCreditCardBox from "@/app/client/ui/NoCreditCardBox";
import CreditScoreTemplate from "../shared/components/creditScoreTemplate";
import ChangePasswordModal from "@/app/client/profile/shared/modals/changePassword";
import VerificateEmailModal from "@/app/client/profile/shared/modals/verificateEmail";
import ValidatePhone from "@/app/client/registration/shared/components/ValidatePhone";
import PersonalDataModal from "@/app/client/registration/shared/modals/PersonalDataModal";
import UserTermsModal from "@/app/client/registration/shared/modals/UserTermsModal";

export default {
    $_veeValidate: {
        validator: "new",
    },
    name: "Profile",
    components: {
        ValidatePhone,
        VerificateEmailModal,
        ChangePasswordModal,
        CreditScoreTemplate,
        PersonalDataModal,
        UserTermsModal,
        CreditCardBox,
        NoCreditCardBox,
    },
    data() {
        return {
            validatePhone: false,
            validateEmail: false,
        };
    },
    created() {
        if (this.authUser && this.authUser.credit_score) {
            this.$store.dispatch("GET_CS_OFFERS");
        }
        this.$store.dispatch("GET_PERSONAL_AND_USER_TERMS_TEXTS");
    },
    computed: {
        authUser() {
            return this.$store.getters.AUTH_USER;
        },
        formValid() {
            this.$validator.validateAll();
            return Object.keys(this.fields).every(
                (field) => this.fields[field] && this.fields[field].valid
            );
        },
        settings() {
            return this.$store.getters.APP_SETTINGS;
        },
    },
    methods: {
        addCreditCard() {
            this.$store.dispatch("OPEN_PAYMENTS_MODAL", true);
        },
        verificateEmailModal() {
            this.$store.dispatch("EMAIL_VALIDATION", true);
            this.$store.dispatch("CHANGE_VERIFICATE_USER_EMAIL", this.authUser).catch((error) => {
                const exception = error.response.data.exception;
                switch (exception) {
                    case "VerificationCodeAlreadySentException":
                        this.$toast.warning(this.$t(`exception.${exception}`, { type: "Email" }));
                        break;
                    default:
                        this.$toast.error(error);
                        break;
                }
            });
        },
        verificatePhoneModal() {
            this.$store
                .dispatch("SET_AUTH_TO_CREDENTIALS", this.authUser)
                .then(() => {
                    this.$store
                        .dispatch("SEND_PHONE_VERIFICATION_CODE")
                        .then(() => {
                            this.$store.dispatch("OPEN_PHONE_VALIDATION");
                        })
                        .catch(() => {
                            const exception = error.response.data.exception;
                            switch (exception) {
                                case "VerificationCodeAlreadySentException":
                                    this.$toast.warning(
                                        this.$t(`exception.${exception}`, { type: "SMS" })
                                    );
                                    break;
                                default:
                                    this.$toast.error(error);
                                    break;
                            }
                        });
                })
                .catch((data) => {
                    this.$toast.error(data);
                });
        },
        changePasswordModal() {
            this.$store.dispatch("CHANGE_PASSWORD_MODAL", true);
        },
        saveProfile() {
            this.$validator.validateAll().then((result) => {
                if (result) {
                    this.authUser.phone = this.authUser.phone.replace(/\D+/g, "");
                    this.$store
                        .dispatch("CHANGE_USER_PROFILE_DATA", this.authUser)
                        .then(() => {
                            this.$toast.success(this.$t("settings_saved"));
                        })
                        .catch((data) => {
                            let msg = "";
                            if (data.response.data.message == "Phone not valid") {
                                msg = this.$t("errors.phone_number_not_valid");
                            } else if (data.response.data.message == "Email not valid") {
                                msg = this.$t("errors.email_not_valid");
                            } else {
                                msg = this.$t("server_error");
                            }
                            this.$toast.error(msg);
                        });
                }
            });
        },
        openPersonalDataModal() {
            this.$store.dispatch("PERSONAL_DATA_MODAL", true);
        },
        openUserTermsModal() {
            this.$store.dispatch("USER_TERMS_MODAL", true);
        },
    },
};
</script>
